import {
  AccountAggregationStatsResponse,
  SearchAccountWithStatsResponseItem,
} from '../../../core/openapi/bff-user-portal';
import { IUserAccount } from './model/user-account.interface';

export class UserAccountsMapper {
  public static fromDto(dto: SearchAccountWithStatsResponseItem): IUserAccount {
    return {
      id: dto.id,
      label: dto.name,
      amountInBtc: dto.amountInBtc ?? 0,
      offlineWorkers: dto.offlineWorkers ?? 0,
      activeWorkers: dto.activeWorkers ?? 0,
      inactiveWorkers: dto.inactiveWorkers ?? 0,
    };
  }

  public static fromAggregatedDto(
    dto: AccountAggregationStatsResponse,
  ): IUserAccount {
    return {
      id: '',
      label: '',
      amountInBtc: dto.amountInBtc ?? 0,
      activeWorkers: dto.activeWorkers ?? 0,
      offlineWorkers: dto.offlineWorkers ?? 0,
      inactiveWorkers: dto.inactiveWorkers ?? 0,
    };
  }
}
